export default __webpack_public_path__ + "static/10-fa2e7a1b20add96c8822475062e1a923.png";